import type { Zone, MetricRow, LatestSummary, SyncRun, AlertRow } from './types';

// Set via `VITE_API_BASE` env at build time. Defaults to same-origin (empty string)
// so the dashboard can be served from the same Worker if desired.
const API_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/$/, '');

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`);
  if (!res.ok) {
    throw new Error(`API ${path} failed: HTTP ${res.status}`);
  }
  return (await res.json()) as T;
}

export async function fetchZones(): Promise<Zone[]> {
  const { zones } = await getJson<{ zones: Zone[] }>('/api/zones');
  return zones;
}

export async function fetchMetrics(
  zoneId: string,
  minutes: number
): Promise<MetricRow[]> {
  const { rows } = await getJson<{ rows: MetricRow[] }>(
    `/api/metrics/${zoneId}?minutes=${minutes}`
  );
  return rows;
}

export async function fetchLatest(zoneId: string): Promise<LatestSummary> {
  return getJson<LatestSummary>(`/api/metrics/${zoneId}/latest`);
}

export async function fetchSyncRuns(limit = 20): Promise<SyncRun[]> {
  try {
    const { runs } = await getJson<{ runs: SyncRun[] }>(`/api/sync-runs?limit=${limit}`);
    return runs;
  } catch {
    return [];
  }
}

export async function fetchAlerts(zoneId: string, limit = 50): Promise<AlertRow[]> {
  try {
    const { alerts } = await getJson<{ alerts: AlertRow[] }>(
      `/api/alerts/${zoneId}?limit=${limit}`
    );
    return alerts;
  } catch {
    return [];
  }
}
